/* import __COLOCATED_TEMPLATE__ from './target-channels-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();